import { render, staticRenderFns } from "./SGEXCL.vue?vue&type=template&id=adf5efa8&scoped=true&"
import script from "./SGEXCL.vue?vue&type=script&lang=js&"
export * from "./SGEXCL.vue?vue&type=script&lang=js&"
import style0 from "./SGEXCL.vue?vue&type=style&index=0&id=adf5efa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf5efa8",
  null
  
)

export default component.exports